import { Container } from 'react-bootstrap';
import styled from 'styled-components/macro';

export const HeaderContainer = styled(Container)`
  background: #08062a;
  height: ${(props) => props.theme.headerHeight};
  min-height: ${(props) => props.theme.headerHeight};
  padding-left: 0;
  padding-right: 21px;
  display: flex;
  align-items: center;
  .navbar-brand {
    display: flex;
    align-items: center;
    padding: 0;
    height: 100%;
    flex: 1;
  }
  .nav {
    height: 100%;
  }
`;

export const SelectWrapper = styled.div`
  margin-right: 5px;
  z-index: 999;
`;

export const HeaderName = styled.div`
  color: white;
  font-size: 14px;
  font-family: 'Inter', sans-serif;

  + svg {
    margin-left: 7px !important;
  }
`;

export const HeaderTitle = styled.div`
  color: #fdfcfb;
  font-size: 16px;
  font-weight: 600;
`;

export const Img = styled.img`
  margin-right: 23px;
  padding: 14px 18px;
`;
